
import Cookies from 'js-cookie'

export default {
    name: 'BaseAlert',

    props: {
        variant: {
            type: String,
            default: 'info',
            validator: function (value) {
                return ['info', 'error', 'success', 'warning'].includes(value)
            },
        },
        faIcon: {
            type: String,
            default: '',
        },
        isRounded: {
            type: Boolean,
            default: true,
        },
        isDismissible: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: null,
        },
        messageId: {
            type: Number,
            default: undefined,
        },
    },

    data() {
        return {
            isDismissed: false,
        }
    },

    computed: {
        backgroundColor() {
            const mapping = {
                info: 'bg-utility-info-lighter',
                success: 'bg-utility-success-lighter',
                warning: 'bg-utility-warning-lighter',
                error: 'bg-utility-error-lighter',
            }

            return mapping[this.variant]
        },
        textColor() {
            const mapping = {
                info: 'text-utility-info-dark',
                success: 'text-utility-success-dark',
                warning: 'text-utility-warning-dark',
                error: 'text-utility-error-dark',
            }

            return mapping[this.variant]
        },
        borderColor() {
            const mapping = {
                info: 'border-utility-info-dark',
                success: 'border-utility-success-dark',
                warning: 'border-utility-warning-dark',
                error: 'border-utility-error-dark',
            }

            return `border ${mapping[this.variant]}`
        },
        rounded() {
            return this.isRounded ? 'rounded' : ''
        },

        isVisible() {
            if (this.isDismissed) {
                return false
            }

            if (!this.isDismissible || this.rememberKey === null) {
                return true
            }

            return Cookies.get(this.rememberKey) === undefined
        },

        rememberKey() {
            if (this.$vnode.key) {
                return `alert-${this.$vnode.key}`
            }

            return null
        },
    },

    methods: {
        dismiss() {
            this.isDismissed = true
            this.$emit('dismissed')

            this.messageId &&
                this.$messages.clear({ messageId: this.messageId })

            if (this.rememberKey !== null) {
                Cookies.set(this.rememberKey, true, { expires: 365 })
            }
        },
    },
}
